// eslint-disable-next-line import/prefer-default-export
export const parseNumberFieldValue = (value) => {
  return value
    ? Number(value)
    : value;
};
